<template>
  <div id="app">
    <div class="bigFlex">
      <NavigationBar />
      <router-view />
    </div>
    <footer class="footer bottomFlex has-background-white-ter">
      <div class="container has-text-centered">
        <p>
          <strong>NuMRis</strong> by
          <a href="https://www.insilicotrials.com">InSilicoTrials Technologies</a>
          <br />
          <router-link :to="{name: 'terms'}">Terms and Conditions</router-link>&nbsp;apply.
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
import NavigationBar from '@/components/NavigationBar.vue';

export default {
  components: {
    NavigationBar,
  },
};
</script>

<style lang="scss">
/* Custom colour palette. Must be defined before importing Bulma. */

$primary: #00466e;
$link: #2274a5;
$info: #1b998b;
$success: #1b998b;
$warning: #e3b505;
$danger: #ee4266;
$dark: $primary;

@import "~bulma/bulma.sass";
@import "~bulma-steps-component/bulma-steps.sass";

/* CSS for sticky footer from https://css-tricks.com/couple-takes-sticky-footer/ */

html {
  height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.bigFlex {
  flex: 1 0 auto;
  background-color: hsl(0, 0%, 96%);
}

.bottomFlex {
  flex-shrink: 0;
}

div.custom-container {
  background-color: white;
  padding: 1.5em;
  border: 1px solid hsl(0, 0%, 90%);
  border-radius: 0px;
  box-shadow: 0px 0px 1em hsl(0%, 0%, 86%);
}
</style>
